import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { useTranslation } from 'react-i18next';

const Footer = ({ content, logo, companyName, year }) => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <img src={logo} alt="Logo" className="h-8 w-auto mb-6" />
            <p className="text-gray-400">{t('footer.description')}</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.services')}</h4>
            <ul className="space-y-2 text-gray-400">
              <li>{t('navigation.services')}</li>
              <li>{t('navigation.workflow')}</li>
              <li>{t('navigation.projects')}</li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.company')}</h4>
            <ul className="space-y-2 text-gray-400">
              <li>{t('footer.aboutUs')}</li>
              <li>{t('footer.careers')}</li>
              <li>{t('footer.blog')}</li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.contact')}</h4>
            <div className="flex space-x-4">
              {content.social.map((item, index) => (
                <a 
                  key={index} 
                  href={item.href} 
                  className="text-gray-400 hover:text-white"
                >
                  <FontAwesomeIcon icon={item.icon === 'linkedin' ? faLinkedin : faWhatsapp} size="lg" />
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>© {year} {companyName}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
